import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DocumentsApi } from '@modules/documents/documents.const';
import {
  AddedDocumentResponse,
  AllDocumentsResponse,
  CallbackPayload,
  DocumentApiResponse,
  DocumentUploadPayload,
  GetDocumentResponse,
  NeededDocumentsResponse,
} from '@modules/documents/documents.interface';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DocumentsResource {
  constructor(private http: HttpClient) {}

  public getNeeded(): Observable<NeededDocumentsResponse> {
    return this.http.get<NeededDocumentsResponse>(
      environment.apiUrl + DocumentsApi.getNeeded
    );
  }

  public getUploaded(): Observable<AllDocumentsResponse> {
    return this.http.get<AllDocumentsResponse>(
      environment.apiUrl + DocumentsApi.getAll
    );
  }

  public upload(
    payload: DocumentUploadPayload
  ): Observable<AddedDocumentResponse> {
    return this.http.post<AddedDocumentResponse>(
      environment.apiUrl + DocumentsApi.upload,
      payload
    );
  }

  public getOne(fileId: string): Observable<GetDocumentResponse> {
    return this.http.post<GetDocumentResponse>(
      environment.apiUrl + DocumentsApi.findById,
      { fileId }
    );
  }

  public delete(fileId: string): Observable<DocumentApiResponse> {
    return this.http.post<DocumentApiResponse>(
      environment.apiUrl + DocumentsApi.delete,
      { fileId }
    );
  }

  public sign(fileId: string): Observable<DocumentApiResponse> {
    return this.http.post<DocumentApiResponse>(
      environment.apiUrl + DocumentsApi.sign,
      { fileId }
    );
  }

  public callback(payload: CallbackPayload): Observable<DocumentApiResponse> {
    return this.http.post<DocumentApiResponse>(
      environment.apiUrl + DocumentsApi.callback,
      payload
    );
  }
}
